import React from 'react';
import PortfolioFilter from './portfolio/components/PortfolioFilter';
import PortfolioGrid from './portfolio/components/PortfolioGrid';
import BackgroundComposer from './background/BackgroundComposer';
import { usePortfolioFilter } from './portfolio/hooks/usePortfolioFilter';
import SectionLabel from './common/SectionLabel';

const Portfolio = () => {
  const { activeFilter, filteredProjects, handleFilterChange } = usePortfolioFilter();

  return (
    <section id="portfolio" className="relative overflow-hidden bg-black">
      <BackgroundComposer>
        <div className="container relative z-10 mx-auto px-4">
          <div className="mb-16 max-w-3xl">
            <SectionLabel>Work</SectionLabel>
            <h2 className="mt-6 text-4xl text-white md:text-5xl">Featured Projects</h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#d0d0d0] md:text-base">
              Discover our innovative solutions that have helped businesses transform
              their digital presence and achieve remarkable growth.
            </p>
          </div>

          <PortfolioFilter 
            activeFilter={activeFilter} 
            onFilterChange={handleFilterChange}
          />

          <PortfolioGrid projects={filteredProjects} />
        </div>
      </BackgroundComposer>
    </section>
  );
};

export default Portfolio;